import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import isEqual from 'lodash/isEqual';
import urlJoin from 'url-join';
import qs from 'query-string';
import { absoluteUrl } from '../../utils/url';
import { updateMetaData } from '../../actions/metaDataActions';
import Modal from '../Modal';
import TopicOverview from './TopicOverview';
import TopicNav from './TopicNav';
import MediaViewer from './MediaViewer';
import MediaGrid from './MediaGrid';


class TopicTree extends Component {
  constructor (props) {
    super(props);
    this.state = {
      videoStats: {},
    };
    this.handleModalRequestClose = this.handleModalRequestClose.bind(this);
    this.getVideoStats = this.getVideoStats.bind(this);
    this.setMetaData = this.setMetaData.bind(this);
  }

  componentDidMount () {
    this.setMetaData();
    this.getVideoStats();
  }

  componentDidUpdate (prevProps, prevState) {
    const { activeTopic, activeIssue } = this.props;
    if (!isEqual(activeTopic, prevProps.activeTopic) || !isEqual(activeIssue, prevProps.activeIssue)) {
      this.setMetaData();
    }
  }

  componentWillUnmount () {
    this.setMetaData(true);
  }

  handleModalRequestClose () {
    const { history, location } = this.props;
    // Remove query string
    history.push(location.pathname);
  }

  getVideoStats () {
    // Get count and total duration of videos for each topic / issue
    const { topics } = this.props;
    const videoStats = {};
    topics.forEach(topic => {
      const videos = topic.videos.filter(m => m.type === 'video');
      let tCount = videos.length;
      let tDuration = videos.reduce((result, m) => (result + (m.duration || 0)), 0);
      topic.subtopics.forEach(issue => {
        const videos = issue.videos.filter(m => m.type === 'video');
        let iCount = videos.length;
        let iDuration = videos.reduce((result, m) => (result + (m.duration || 0)), 0);
        videoStats[issue.uid] = {
          count: iCount,
          duration: iDuration,
        };
        tCount += iCount;
        tDuration += iDuration;
      });
      videoStats[topic.uid] = {
        count: tCount,
        duration: tDuration,
      };
    });

    this.setState({ videoStats });
  }

  setMetaData (reset = false) {
    const { location, actions, titleProps, activeTopic, activeIssue } = this.props;
    const url = absoluteUrl(location.pathname);
    let title = titleProps.name;
    let description = titleProps.shortDescription;
    if (activeIssue) {
      title = activeIssue.name;
      description = activeIssue.description;
    } else if (activeTopic) {
      title = activeTopic.name;
      description = activeTopic.shortDescription;
    }
    actions.updateMetaData({
      page: reset ? {} : { url, title, description },
    });
  }

  renderMedia () {
    let { location, breakpoint, baseUrl, activeTopic, activeIssue, activeMedia } = this.props;

    let viewerBaseUrl = urlJoin(baseUrl, activeTopic.slug);
    let viewerMedia = activeTopic.videos;
    if (activeIssue) {
      viewerBaseUrl = urlJoin(baseUrl, activeTopic.slug, activeIssue.slug);
      viewerMedia = activeIssue.videos;
    }

    if (!activeMedia && viewerMedia.length === 1) {
      activeMedia = viewerMedia[0];
    }

    if (breakpoint.lessThan.lg) {
      const params = qs.parse(location.search);
      let modalContent = {};
      if (activeIssue) {
        modalContent = {
          title: activeIssue.name,
          body: activeIssue.description,
          videos: activeIssue.videos.map(m => ({
            title: m.name,
            slug: m.slug,
            body: m.longDescription,
            vimeoId: m.metadata.sourceId,
            vimeoUrl: m.metadata.sourceUrl,
          })),
        };
      } else if (activeTopic) {
        modalContent = {
          title: activeTopic.name,
          body: activeTopic.longDescription,
          videos: activeTopic.videos.map(m => ({
            title: m.name,
            slug: m.slug,
            body: m.longDescription,
            vimeoId: m.metadata.sourceId,
            vimeoUrl: m.metadata.sourceUrl,
          })),
        };
      }
      const modalOpen = params.showOverlay === 'true' && Object.keys(modalContent).length > 0;
      return (
        <Modal
          key="modal"
          content={modalContent}
          isOpen={modalOpen}
          onRequestClose={this.handleModalRequestClose}
        />
      );
    } else {
      return (
        <div className="topic-tree-media-container">
          {activeMedia ? (
            <MediaViewer baseUrl={viewerBaseUrl} media={viewerMedia} activeMedia={activeMedia} />
          ) : (
            <MediaGrid baseUrl={viewerBaseUrl} media={viewerMedia} />
          )}
        </div>
      );
    }
  }

  render () {
    const { breakpoint, topics, activeTopic } = this.props;
    const { videoStats } = this.state;
    if (!activeTopic) {
      return <TopicOverview mobileUi={breakpoint.lessThan.lg} topics={topics} />;
    }

    return (
      <div className="topic-tree-main mt-4">
        <TopicNav mobileUi={breakpoint.lessThan.lg} videoStats={videoStats} {...this.props} />
        {this.renderMedia()}
      </div>
    );
  }
}

TopicTree.propTypes = {
  baseUrl: PropTypes.string,
  topics: PropTypes.arrayOf(PropTypes.object),
  activeTopic: PropTypes.object,
  activeIssue: PropTypes.object,
  activeMedia: PropTypes.object,
};

const mapStateToProps = ({ breakpoint }) => ({ breakpoint });

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ updateMetaData }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TopicTree));



// WEBPACK FOOTER //
// ./src/components/TopicTree/TopicTree.js